<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">

			<el-form-item label="图标:">
				<el-upload class="avatar-uploader" :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="ruleForm.icon_url" :src="ruleForm.icon_url" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
			
			<el-form-item label="通道名称" prop="pay_name">
				<el-input size="small" v-model="ruleForm.pay_name"></el-input>
			</el-form-item>
			
			<el-form-item label="通道编码" prop="pay_code">
				<el-input size="small" v-model="ruleForm.pay_code"></el-input>
			</el-form-item>
			
			<el-form-item label="单位" prop="unit">
				<el-input size="small" v-model="ruleForm.unit"></el-input>
			</el-form-item>
				
			<el-form-item label="充值说明:" prop="pay_desc">
				<el-input size="small" v-model="ruleForm.pay_desc"></el-input>
			</el-form-item>
			
			<el-form-item label="最低限额:" prop="low_limit">
				<el-input type="number" size="small" v-model="ruleForm.low_limit"></el-input>
			</el-form-item>
			<el-form-item label="最高限额:" prop="high_limit">
				<el-input type="number" size="small" v-model="ruleForm.high_limit"></el-input>
			</el-form-item>
			<el-form-item label="快捷金额:" prop="amount_list">
				<el-input size="small" v-model="ruleForm.amount_list"></el-input>
			</el-form-item>
			<el-form-item label="配置JSON:">
				<el-input size="small" v-model="ruleForm.config_json"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">立即添加</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				ruleForm: {
					pay_name:'',
					pay_code:'',
					pay_desc:'',
					unit:'',
					icon_url:'',
					low_limit:1,
					high_limit:99999,
					amount_list:'',
					config_json:''
				},
				rules: {
					icon_url: [{required: true, message: '请输入上传图标', trigger: 'blur'}],
					pay_name: [{required: true, message: '请输入渠道名称', trigger: 'blur'}],
					pay_code: [{required: true, message: '请输入渠道编码', trigger: 'blur'}],
					unit: [{required: true, message: '请输入单位', trigger: 'blur'}],
					pay_desc: [{required: true, message: '请输入渠道说明', trigger: 'blur'}],
					low_limit: [{required: true, message: '请输入最低限额', trigger: 'blur'}],
					high_limit: [{required: true, message: '请输入最高限额', trigger: 'blur'}],
					amount_list: [{required: true, message: '请输入快捷金额列表', trigger: 'blur'}],
					
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				console.log(res);
				if(res.code == 200)
				{
					this.ruleForm.icon_url = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Recharge/addPayin", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 80px;
	    height: 80px;
	    line-height: 80px;
	    text-align: center;
		border: solid 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 80px;
	    height: 80px;
	    display: block;
	  }
</style>